import React from 'react';
import { Link } from 'react-router-dom';
import { openQuoteChat } from '../../../utils/site';
import siteChromeData from '../../../data/content/siteChrome.json';
import './footer.css';

const renderSocialIcon = (network) => {
    switch (network) {
        case 'facebook':
            return (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z" />
                </svg>
            );
        case 'twitter':
            return (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M23 3a10.9 10.9 0 0 1-3.14 1.53 4.48 4.48 0 0 0-7.86 3v1A10.66 10.66 0 0 1 3 4s-4 9 5 13a11.64 11.64 0 0 1-7 2c9 5 20 0 20-11.5a4.5 4.5 0 0 0-.08-.83A7.72 7.72 0 0 0 23 3z" />
                </svg>
            );
        default:
            return (
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <rect x="2" y="2" width="20" height="20" rx="5" ry="5" />
                    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z" />
                    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5" />
                </svg>
            );
    }
};

const renderFooterLink = (item, className) => {
    if (item.type === 'internal') {
        return <Link to={item.to} className={className}>{item.label}</Link>;
    }

    if (item.type === 'action') {
        return <button type="button" className={className} onClick={openQuoteChat}>{item.label}</button>;
    }

    return <a href={item.href} className={className} target="_blank" rel="noreferrer">{item.label}</a>;
};

const Footer = () => {
    const { footer } = siteChromeData;

    return (
        <footer className="footer">
            <div className="container">
                <div className="footer-content">
                    <div className="footer-brand">
                        <div className="footer-logo">{footer.brandName}</div>
                        <p className="footer-description">{footer.description}</p>
                        <div className="footer-social">
                            {footer.socialLinks.map((item) => (
                                <a key={item.network} href={item.href} className="footer-social-link" aria-label={item.label} target="_blank" rel="noreferrer">
                                    {renderSocialIcon(item.network)}
                                </a>
                            ))}
                        </div>
                    </div>

                    {footer.sections.map((section) => (
                        <div key={section.title}>
                            <h4 className="footer-section-title">{section.title}</h4>
                            <ul className="footer-links">
                                {section.links.filter((item) => !item.hidden).map((item) => (
                                    <li key={item.label}>
                                        {renderFooterLink(item, `footer-link${item.type === 'action' ? ' footer-link-button' : ''}`)}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>

                <div className="footer-bottom">
                    <div className="footer-copyright">{footer.copyright}</div>
                    <div className="footer-bottom-links">
                        {footer.bottomLinks.filter((item) => !item.hidden).map((item) => (
                            <React.Fragment key={item.label}>
                                {renderFooterLink(item, `footer-bottom-link${item.type === 'action' ? ' footer-bottom-button' : ''}`)}
                            </React.Fragment>
                        ))}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;
